import Dashboard from 'src/wrapper/dashboard/admin';
import Account from 'src/wrapper/account';
import carList from 'src/wrapper/admins/car-list';
import CarDetail from 'src/wrapper/admins/car-detail';
import HumanResources from 'src/wrapper/admins/human-resources';
import PartnerList from 'src/wrapper/admins/partner-list';
import PartnerDetail from 'src/wrapper/admins/partner-detail';
import PayrollList from 'src/wrapper/admins/payroll-list';
import RepairRequests from 'src/wrapper/admins/repair-requests';
import WorkSchedule from 'src/wrapper/admins/work-schedule';
import AccountList from 'src/wrapper/accounts/list';
import AccountDetail from 'src/wrapper/accounts/detail';
import GroupList from 'src/wrapper/admins/group-list';
import GroupDetail from 'src/wrapper/admins/group-detail';
import CourseList from 'src/wrapper/admins/course-list';
import CourseDetail from 'src/wrapper/admins/course-detail';
import TrackingList from 'src/wrapper/admins/tracking-list';

export const adminRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.cars.index, component: carList },
    { path: paths.cars.details, component: CarDetail },
    { path: paths.staff.index, component: HumanResources },
    { path: paths.partners.index, component: PartnerList },
    { path: paths.partners.details, component: PartnerDetail },
    { path: paths.payrolls.index, component: PayrollList },
    { path: paths.repairs.requests, component: RepairRequests },
    { path: paths.schedules.work.index, component: WorkSchedule },
    { path: paths.accounts.index, component: AccountList },
    { path: paths.accounts.details, component: AccountDetail },
    { path: paths.groups.index, component: GroupList },
    { path: paths.groups.details, component: GroupDetail },
    { path: paths.courses.index, component: CourseList },
    { path: paths.courses.details, component: CourseDetail },
    { path: paths.tracking.index, component: TrackingList },
  ];
};
